import styled from 'styled-components'

import theme from 'theme_'
import { TableWithPaginationWrapper } from 'components/Table/styles'

export const DomainJobsTableContainer = styled.div`
  @media ${theme.devices.tablet} {
    width: max-content;
    min-width: 100%;
  }
`

export const DomainJobsSubContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  border: 1px solid red;
  @media ${theme.devices.tablet} {
    width: max-content;
    min-width: 100%;
  }
`

export const DomainJobsListWrapper = styled(TableWithPaginationWrapper)``
